export default "data:text/csv;base64,77u/ZGVidG9yTnVtYmVyO2J1ZGdldA0KOTk5OTk7MTAwMDAwDQo4ODg4ODsyMDAwMDA="